import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TenantEmailBannerSection.scss';
import { Button, Icon } from 'design-system-web';
import { H4 } from 'components/typography';
import { ViewTenantEmailBanner } from './ViewTenantEmailBanner';
import { EditTenantEmailBanner } from './EditTenantEmailBanner';
import { Flex, Tooltip } from 'components';
import { ICON_SET_FONTAWESOME } from 'lane-shared/helpers/constants/icons';

type TenantEmailBannerSectionProps = {
  channel: { _id?: string } | undefined;
  visitorEmailBannerId: string | null | undefined;
};

export const TenantEmailBannerSection = ({
  channel,
  visitorEmailBannerId,
}: TenantEmailBannerSectionProps) => {
  const { t } = useTranslation();
  const [isEditMode, setIsEditMode] = useState(false);

  const handleSave = (_selectedBannerId: string | null) => {
    setIsEditMode(false);
  };

  return (
    <div data-test="tenant-email-banner-section">
      <div className={styles.Header}>
        <div className={styles.SectionHeader}>
          <Flex align="center">
            <H4 className={styles.Title}>
              {t(
                'web.admin.channel.settings.tenantManagement.tenant.details.tenantEmailBannerSection.title'
              )}
            </H4>
            <Tooltip
              TooltipComponent={
                <>{t`web.admin.channel.settings.tenantManagement.tenant.details.tenantEmailBannerSection.tooltip`}</>
              }
              placement="right"
            >
              <Icon
                className="cursor-pointer"
                name="info-circle"
                type="far"
                set={ICON_SET_FONTAWESOME}
                size="medium"
              />
            </Tooltip>
          </Flex>
          {!isEditMode && (
            <Button
              variant="secondary"
              size="medium"
              onClick={() => setIsEditMode(true)}
              testId="edit-tenant-email-banner"
            >
              {t(
                'web.admin.channel.settings.tenantManagement.tenant.details.tenantEmailBannerSection.edit'
              )}
            </Button>
          )}
        </div>
        <div className={styles.Description}>
          <p data-test="tenant-email-banner-empty">
            {t(
              'web.admin.channel.settings.tenantManagement.tenant.details.tenantEmailBannerSection.description'
            )}
          </p>
        </div>
      </div>
      {isEditMode ? (
        <EditTenantEmailBanner
          channel={channel}
          initialVisitorEmailBannerId={visitorEmailBannerId}
          onSave={handleSave}
          onCancel={() => setIsEditMode(false)}
        />
      ) : (
        <ViewTenantEmailBanner visitorEmailBannerId={visitorEmailBannerId} />
      )}
    </div>
  );
};
